import { api, unwrap } from './client';

/**
 * Payments API client.
 *
 * Backend wraps every response in ApiResponse<T>; always pass through unwrap().
 * Paths begin with /finance/payments.
 *
 * Supports listing all payments at /finance/payments and invoice-specific
 * payments at /finance/payments/invoice/{invoiceId}.
 */

export async function listPayments(invoiceId = null) {
  const res = invoiceId == null
    ? await api.get('/finance/payments')
    : await api.get(`/finance/payments/invoice/${invoiceId}`);
  return unwrap(res) || [];
}

export async function listPaymentsForInvoice(invoiceId) {
  return listPayments(invoiceId);
}

/**
 * Record a payment against an invoice.
 *
 * payload shape (PaymentRequest):
 *   {
 *     invoiceId:      number,
 *     amount:         number,
 *     paymentMethod:  PaymentMethod,
 *     referenceNo?:   string,
 *     notes?:         string,
 *     paidAt?:        ISO datetime string
 *   }
 */
export async function recordPayment(payload) {
  const res = await api.post('/finance/payments', payload);
  return unwrap(res);
}

export async function updatePayment(id, payload) {
  const res = await api.put(`/finance/payments/${id}`, payload);
  return unwrap(res);
}
